import { Injectable, Component } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Config } from '../config/config';

@Injectable()
export class HttpService extends Config {

  constructor(private http: HttpClient) {
    super()
  }

  sendGetRequest(httpUrl, options) {

    return new Promise(async (resolve, reject) => {
      this.http.get<any>(httpUrl, options).subscribe(respone => {
        (this.enableConsoleLog)
        {
          console.log('----------HTTP SERVICE | GET----------\n' +
            'API::' + httpUrl + '\n' +
            'HEADERS::' + + JSON.stringify(options) + '\n' +
            'RESPONSE::' + JSON.stringify(respone));
        }
        resolve(respone);
      }, (err) => {

        console.log('----------HTTP SERVICE ERROR | GET----------\n' +
          'API::' + httpUrl + '\n' +
          'HEADERS::' + + JSON.stringify(options) + '\n' +
          'ERROR::' + err);

        reject(err);
      });
    });
  }

  sendPostRequest(httpUrl, postData, options) {

    // if (postData) {
    //   if (typeof postData == 'string') {
    //     postData = postData + '&channel=' + this.channel;
    //   } else {
    //     if (!postData.channel) {
    //       postData.channel = this.channel;
    //     }
    //   }
    // }

    return new Promise(async (resolve, reject) => {
      this.http.post<any>(httpUrl, postData, options).subscribe(respone => {
        (this.enableConsoleLog)
        {
          console.log('----------HTTP SERVICE | POST----------\n' +
            'API::' + httpUrl + '\n' +
            'HEADERS::' + + JSON.stringify(options) + '\n' +
            'POST DATA::' + JSON.stringify(postData) + '\n' +
            'RESPONSE::' + JSON.stringify(respone));
        }
        resolve(respone);
      }, (err) => {

        console.log('----------HTTP SERVICE ERROR | POST----------\n' +
          'API::' + httpUrl + '\n' +
          'HEADERS::' + + JSON.stringify(options) + '\n' +
          'POST DATA::' + JSON.stringify(postData) + '\n' +
          'ERROR::' + err);

        reject(err);
      });
    });
  }

  sendPostRequestData(httpUrl, postData, options) {
    return new Promise(async (resolve, reject) => {
      this.http.post<any>(httpUrl, postData, options).subscribe(respone => {
        (this.enableConsoleLog)
        {

          console.log('----------HTTP SERVICE | POST----------\n' +
            'API::' + httpUrl + '\n' +
            'HEADERS::' + + JSON.stringify(options) + '\n' +
            'POST DATA::' + JSON.stringify(postData) + '\n' +
            'RESPONSE::' + JSON.stringify(respone));
        }
        resolve(respone);
      }, (err) => {

        console.log('----------HTTP SERVICE ERROR | POST----------\n' +
          'API::' + httpUrl + '\n' +
          'HEADERS::' + + JSON.stringify(options) + '\n' +
          'POST DATA::' + JSON.stringify(postData) + '\n' +
          'ERROR::' + err);

        reject(err);
      });
    });
  }


}


